import React, { forwardRef, Ref } from 'react';
import { Icon, IconPositionInInput, Input } from 'view/atoms';
import { calendar } from 'static/icons/resizable';
import { FiltersTextBtn } from 'enums';
import { CustomDateInputProps } from './CustomDateInput.model';

export const CustomDateInput = forwardRef(
  (
    {
      value,
      onClick,
      disabled,
      placeholder,
      changeHandler,
      onClickOutside,
      requiredText,
      ignoreErrors,
      isDatePickerOpen,
      isValueSelected,
      dateInputStart,
      customStyles,
    }: CustomDateInputProps,
    ref: Ref<HTMLInputElement>,
  ) => {
    const isIconActive = isDatePickerOpen || isValueSelected;

    return (
      <Input
        type='date'
        icon={
          <Icon
            src={calendar}
            style={{ filter: isIconActive ? '' : FiltersTextBtn.gray2 }}
          />
        }
        iconPosition={IconPositionInInput.left}
        defaultValue={value}
        onClick={onClick}
        onChangeDateInput={changeHandler}
        onDateClickOutSide={onClickOutside}
        disabled={disabled}
        placeholder={placeholder}
        ref={ref}
        requiredText={requiredText}
        ignoreDateErrors={ignoreErrors}
        dateInputStart={dateInputStart}
        isDatePickerOpen={isDatePickerOpen}
        customStyles={customStyles}
      />
    );
  },
);
